import { render, staticRenderFns } from "./Especialista.vue?vue&type=template&id=0c845c39"
import script from "./Especialista.vue?vue&type=script&lang=js"
export * from "./Especialista.vue?vue&type=script&lang=js"
import style0 from "./Especialista.vue?vue&type=style&index=0&id=0c845c39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports